import { render, staticRenderFns } from "./inputInvoiceTitle.vue?vue&type=template&id=5b10a2b4&scoped=true"
import script from "./inputInvoiceTitle.vue?vue&type=script&lang=js"
export * from "./inputInvoiceTitle.vue?vue&type=script&lang=js"
import style0 from "./inputInvoiceTitle.vue?vue&type=style&index=0&id=5b10a2b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b10a2b4",
  null
  
)

export default component.exports